


































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import Local from '@/app/module/local'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class AccountSearch extends Vue {
  private account: number = this.$store.state.accountState.choiceAccountType
  private search: string = this.$store.state.accountState.searchText
  private constantValue: any = []

  @Prop() private count!: number

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
  }

  private doAccountSearch () {
    /* ユーザータイプで絞り込み */
    this.$store.commit('accountState/setChoiceAccountType', this.account)

    /* キーワード検索 */
    this.$store.commit('accountState/setSearchText', this.search)

    this.$emit('search-list')
  }

  private doClear () {
    this.account = 0
    this.search = ''

    /* stateリセット */
    this.$store.commit('accountState/setChoiceAccountType', 0)
    this.$store.commit('accountState/setSearchText', '')
    this.$store.commit('accountState/setSortNum', '2')
    this.$store.commit('accountState/setSortAsc', true)

    this.$emit('reset-list')
    this.$forceUpdate()
  }
}
